<div class="img-header">
  <mat-icon (click)="back()" svgIcon="mat:arrow_back_ios" class="back"></mat-icon>
  <img *ngIf="workout" [src]="environment.workouts+'/'+workout._id+'/images/main'">
  <img *ngIf="!workout" src="" alt="" style="height: 170px;">
</div>
<div class="container" *ngIf="workout">
  <h2>{{workout?.i18nName[translate.currentLang.toUpperCase()]}}</h2>
  <p>{{"WORKOUT.WORKOUT-DETAIL.REQ-EQUIP" | translate}}</p>
  <div class="equipments-slider">
    <swiper-container [slidesPerView]="2.5">
      <swiper-slide *ngFor="let slide of workout.equipmentsMap | keyvalue; let i = index">
        <div class="slide">
          <div class="equip-chip" (click)="equipFullName(slide.value[translate.currentLang.toUpperCase()])">
            <img
              [src]="'assets/img/equipsIcons/'+equipNameConvert(slide.value[translate.currentLang.toUpperCase()])+'.svg'">
            <p>{{slide.value[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
    <!-- <ion-popover [isOpen]="popOverDetails.isOpen"
      (didDismiss)="popOverDetails.open = false; popOverDetails.name = null">
      <ng-template>
        <ion-content class="ion-padding">{{popOverDetails.name}}</ion-content>
      </ng-template>
    </ion-popover> -->
  </div>
  <div class="phases-container">
    <div class="phase" *ngFor="let phase of workout.phases; let k = index">
      <p class="phase-name">
        {{phase.i18nName[translate.currentLang.toUpperCase()]}} - {{phase.repetitions}} <span
          *ngIf="phase.repetitions > 1">{{"WORKOUT.WORKOUT-DETAIL.SETS" | translate}}</span><span
          *ngIf="phase.repetitions <= 1">{{"WORKOUT.WORKOUT-DETAIL.SET" | translate}}</span>
      </p>
      <p class="set-rest" *ngIf="phase.restTimeSeconds && phase.restTimeSeconds > 0">
        <mat-icon svgIcon="mat:timer"></mat-icon>
        <span>{{convertToMMSS(phase.restTimeSeconds)}} {{"WORKOUT.WORKOUT-DETAIL.REST_2" | translate}}</span>
      </p>
      <div class="exercise" *ngFor="let exercise of phase.exercises; let i = index">
        <ion-thumbnail>
          <img [hidden]="!imageLoadedIds.includes(exercise.exerciseId)" (load)="onImageLoad(exercise.exerciseId)"
            [src]="environment.exercises+'/'+exercise.exerciseId+'/images/main'">
          <div class="skeleton" *ngIf="!imageLoadedIds.includes(exercise.exerciseId)" style="height: 60px; border-radius: 12px; width: 100%;"></div>
        </ion-thumbnail>
        <div>
          <p class="exercise-name">
            {{ workout.exerciseMap[exercise.exerciseId].i18nName[translate.currentLang.toUpperCase()] }}
          </p>

          <p class="exercise-infos" *ngIf="exercise.executionTimeSeconds > 0">
            <mat-icon svgIcon="mat:timer"></mat-icon>
            {{ exercise.executionTimeSeconds < 60 ? exercise.executionTimeSeconds : convertToMMSS(exercise.executionTimeSeconds)
              }} <span *ngIf="exercise.executionTimeSeconds < 60" class="left-px">
              {{"WORKOUT.WORKOUT-DETAIL.SECS" | translate}}
              <span *ngIf="exercise.eachSideFlag" style="margin-left: 3px;">
                {{"WORKOUT.WORKOUT-DETAIL.SIDE" | translate}}
              </span>
              </span>

              <span *ngIf="exercise.executionTimeSeconds === 60" class="left-px">
                {{"WORKOUT.WORKOUT-DETAIL.MIN" | translate}}
                <span *ngIf="exercise.eachSideFlag" style="margin-left: 3px;">
                  {{"WORKOUT.WORKOUT-DETAIL.SIDE" | translate}}
                </span>
              </span>

              <span *ngIf="exercise.executionTimeSeconds > 60" class="left-px">
                {{"WORKOUT.WORKOUT-DETAIL.MINS" | translate}}
                <span *ngIf="exercise.eachSideFlag" style="margin-left: 3px;">
                  {{"WORKOUT.WORKOUT-DETAIL.SIDE" | translate}}
                </span>
              </span>
          </p>

          <p class="exercise-infos" *ngIf="exercise.executionTimeSeconds === 0">
            <mat-icon svgIcon="mat:fitness_center"></mat-icon>
            {{ exercise.repetitions }} {{"WORKOUT.WORKOUT-DETAIL.REPS" | translate}}
            <span *ngIf="exercise.eachSideFlag" style="margin-left: 3px;">
              {{"WORKOUT.WORKOUT-DETAIL.SIDE" | translate}}
            </span>
          </p>
        </div>
        <span class="exercise-detail-icon" (click)="elaborateExerciseDetail(exercise.exerciseId)">
          <mat-icon svgIcon="mat:info"></mat-icon>
        </span>

        <span class="swap-icon" *ngIf="workout.exerciseMap[exercise.exerciseId].exerciseAlternativeId"
          (click)="openModalSwapExercise(workout.exerciseMap[exercise.exerciseId], workout.exerciseMap[workout.exerciseMap[exercise.exerciseId].exerciseAlternativeId], k, i)">
          <mat-icon svgIcon="mat:swap_horiz"></mat-icon>
        </span>
      </div>
      <div class="linea" *ngIf="workout.phases.length-1 > k">
        <span>
          <img src="../../assets/img/thunderbolt_violet.svg" alt="">
        </span>
      </div>
    </div>
  </div>
  <div class="footer-position">
    <button class="its-button start-workout-btn" (click)="startWorkout()"
      *ngIf="!resumeBtn">{{"WORKOUT.WORKOUT-DETAIL.START-BTN" | translate}}</button>
    <button class="its-button" (click)="resumeWorkout()" *ngIf="resumeBtn">{{"WORKOUT.WORKOUT-DETAIL.RESUME-BTN" |
      translate}}</button>
    <p *ngIf="resumeBtn" (click)="restartWorkout()">{{"WORKOUT.WORKOUT-DETAIL.RESTART-BTN" | translate}}</p>
  </div>
</div>

<div class="container" *ngIf="!workout">
  <h2><div class="skeleton" style="width: 50%; height: 24px;"></div></h2>
  <p>{{"WORKOUT.WORKOUT-DETAIL.REQ-EQUIP" | translate}}</p>
  <div class="equipments-slider">
    <swiper-container [slidesPerView]="2.5">
      <swiper-slide *ngFor="let slide of equipPlaceholder; let i = index">
        <div class="slide">
          <div class="equip-chip">
            <div class="skeleton"
              style="width: 30%; height: 20px; margin-right: 5px;"></div>
            <div class="skeleton" style="width: 70%; height: 15px;"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
  <div class="phases-container">
    <div class="phase">
      <p class="phase-name">
        <span class="skeleton" style="width: 70%; height: 19px;"></span>
      </p>
      <div class="skeleton exercise" style="height: 80px;"></div>
      <div class="skeleton exercise" style="height: 80px;"></div>
      <div class="skeleton exercise" style="height: 80px;"></div>
      <div class="linea">
        <span><div class="skeleton" style="width: 100px;"></div></span>
      </div>
    </div>
  </div>
  <div class="footer-position">
    <button class="its-button" disabled>{{"WORKOUT.WORKOUT-DETAIL.START-BTN" | translate}}</button>
  </div>
</div>
